import { usePrices } from "@/lib/usePrices";
import { fmtPrice } from "@/lib/api";
import { TrendingUp, TrendingDown } from "lucide-react";

export default function TickerTape() {
  const { prices } = usePrices();
  const items = Object.values(prices);
  if (items.length === 0) {
    return (
      <div className="h-12 border-y border-[#E6EBF1] bg-[#F6F9FC] flex items-center px-6 overflow-hidden">
        <span className="text-xs font-ticker text-slate-400 tracking-widest">CONNECTING LIVE MARKET FEED…</span>
      </div>
    );
  }
  const row = [...items, ...items];
  return (
    <div
      data-testid="ticker-tape"
      className="border-y border-[#E6EBF1] bg-[#F6F9FC] overflow-hidden h-12 flex items-center"
    >
      <div className="animate-marquee flex whitespace-nowrap">
        {row.map((t, i) => {
          const up = t.changePct >= 0;
          return (
            <div key={`${t.symbol}-${i}`} className="flex items-center gap-2 px-6 font-ticker text-xs">
              <span className="text-[#425466] font-semibold">{t.name}/USDT</span>
              <span className="text-[#0A2540] font-semibold">${fmtPrice(t.price)}</span>
              <span className={`flex items-center gap-1 ${up ? "text-emerald-600" : "text-red-500"}`}>
                {up ? <TrendingUp size={12} /> : <TrendingDown size={12} />}
                {up ? "+" : ""}{t.changePct.toFixed(2)}%
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
